import styled from 'styled-components/macro';

import { white, blue, graySecondaryDark } from '../../styles/colors';

export const Backdrop = styled.div`
  background-color: ${graySecondaryDark};
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  z-index: 1098;
  top: 0;
  left: 0;
`;

export const LoadingContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 1099;
  .bouncer {
    width: 18px;
    height: 18px;
    margin: 5px;
    background-color: ${white};
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    &.bounce1 {
      animation-delay: -0.32s;
    }
    &.bounce2 {
      animation-delay: -0.16s;
    }
  }

  @keyframes sk-bouncedelay {
    0% {
      background-color: ${white};
    }
    40% {
      background-color: ${blue};
    }
    80% {
      background-color: ${white};
    }
    100% {
      background-color: ${white};
    }
  }
`;
